import axios from "axios";

const state = {
    pageTitle:'MediaGallery',
    navItems:[
        { title: 'Home', icon: 'mdi-view-dashboard', path:'/', name: 'MediaGallery', tooltip: 'Home' },
        { title: 'Projects', icon:'mdi-table', path:'/mg/list/projects', name: 'Projects', tooltip: 'Projects'},
        { title: 'Guidelines', icon: 'mdi-text-box-outline', path:'', name: 'Guidelines', tooltip: 'Guidelines' },
        { title: 'Tutorial', icon: 'mdi-lifebuoy', path:'/tutorial', name: 'Tutorial Videos', tooltip: 'Tutorial' },
    ],
    mgHelp: [
        {
            icon:'mdi-card-account-mail',
            name: 'Contact Us',
            to: '/mg/contact_us',
            newTab: false,
        },
        {
            icon:'mdi-lightbulb',
            name:'New Feature',
            to: 'https://forms.clickup.com/9015362413/f/8cnq0vd-4075/VHL65EA2GQ2YRV443U',
            newTab: true,
        },
        {
            icon:'mdi-bug',
            name:'Bug Report',
            to: 'https://forms.clickup.com/9015362413/f/8cnq0vd-4115/Y9UYF25NBFIOJTJFRR',
            newTab: true,
        },
        {
            icon:'mdi-format-list-bulleted',
            name: 'Changes',
            to: '/mg/welcome',
            newTab: false,
        },
    ],
    contactUsList: [
        {
            id: 2246,
            name: "ICRT Helpdesk",
            email: "helpdesk@international-testing.org",
            bio: "This account is used for dealing with any technical or IT issues related to ProjectLink, ProductTracker, MediaGallery,  EvalDB, or AccessFinancials. This account is monitored daily by the ICRT team and you should expect to get a response within 24 hours. In very urgent cases you can send an email to michael.grant@international-testing.org."
        },
        {
            id: 2242,
            name: "ICRT Invoicing",
            email: "invoice@international-testing.org",
            bio: "This account is used for dealing with Costshare or Invoicing related issues. This account is monitored daily by the ICRT team and you should expect to get a response within 24 hours. In very urgent cases you can send an email to michael.grant@international-testing.org."
        },
        {
            id: 2241,
            name: "ICRT Finance Team",
            email: "finance@international-testing.org",
            bio: "This account is used for dealing with any general finance related issues. This account is monitored daily by the ICRT team and you should expect to get a response within 24 hours. In very urgent cases you can send an email to michael.grant@international-testing.org."
        },

    ],
    icrtServicesList:[
        {
            icon:'projectlink',
            name: ["Project", "Link"],
            to: 'https://projectlink.international-testing.org/'
        },
        {
            icon: 'producttracker',
            name: ["Product", "Tracker"],
            to: 'https://producttracker.org/'
        },
        {
            icon: 'mediagallery',
            name: ["Media", "Gallery"],
            to: 'https://media.international-testing.org/'
        },
        {
            icon: 'evaldb',
            name: ["Eval", "DB"],
            to: 'https://evaldb4.international-testing.org/'
        },
        {
            icon: 'knowledgehub',
            name: ["Knowledge", "Hub"],
            to: 'https://projectlink.international-testing.org/pl/knowledgeHub'
        },
        {
            icon: 'api',
            name: ["API", "Gateway"],
            to: 'https://api.icrt.io/'
        }
    ],
}
const getters = {
    getPageTitle: state => state.pageTitle,
    mgHelp: state => state.mgHelp,
    contactUsList: state => state.contactUsList,
    navItems: state => state.navItems,
    icrtServicesList: state => state.icrtServicesList,
}
const mutations = {
    setPageTitle: (state, data) => state.pageTitle = data,
}

const actions = {
    changePageTitle({commit}, title){
        commit('setPageTitle', title);
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
}
